<template>
  <div class="page">
    <!--头部-->
    <div class="title"><i class="iconfont icon-lirunbiao-normal"></i>毛利润浏览</div>

    <div class="page-content">
      <!--body-->
      <el-form style="font: bold" :inline="true" label-width="110px" size="small" :model="formInline">
        <el-form-item label="SKU：">
          <el-input v-model="formInline.sku" clearable placeholder="SKU"></el-input>
        </el-form-item>
        <el-form-item label="属性：">
          <el-input v-model="formInline.attribute" clearable placeholder="属性"></el-input>
        </el-form-item>
        <el-form-item label="站点：">
          <el-select v-model="formInline.site" style="width: 100%" clearable placeholder="请选择">
            <el-option v-for="types in dataSites" :key="types.codeValue" :value="types.codeValue" v-text="types.codeName" :label="types.codeName" />
          </el-select>
        </el-form-item>
        <el-form-item label="店铺名称：">
          <el-select v-model="formInline.shopName" clearable filterable placeholder="请选择">
            <!-- <el-option label="请选择" value /> -->
            <el-option v-for="types in dataShops" :key="types.shopName" :value="types.shopName" v-text="types.shopName" :label="types.shopName" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="queryParams" style="backgroundcolor: #2a3861; bordercolor: transparent">查询 </el-button>
        </el-form-item>
      </el-form>
      <!-- 表格区域  :loading="loading"-->
      <el-table
        height="calc(100% - 150px)"
        :data="tableData"
        border
        :header-cell-style="{
          'text-align': 'center',
          background: '#F5F6FA',
          color: '#646E92',
        }"
        style="
            width: 96%;
            margin-top: 10px;
            margin-left: 25px;
            color: #666e92;
            font-size: 14px;
          "
        :cell-style="{ 'text-align': 'center' }"
        @cell-dblclick="editData"
      >
        <el-table-column prop="belongMonthly" label="所属月份" show-overflow-tooltip fixed> </el-table-column>
        <el-table-column prop="site" label="站点" show-overflow-tooltip> </el-table-column>

        <el-table-column prop="shopName" label="店铺" width="160" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="sku" label="SKU" width="180" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="attribute" label="属性" width="180" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="cost" label="采购成本" width="100" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="hytcfyHigh" label="头程费" show-overflow-tooltip width="200"> </el-table-column>
        <el-table-column prop="remark" label="头程类型" show-overflow-tooltip width="200"> </el-table-column>
        <!-- <el-table-column
            prop="hytcfyHigh"
            label="海运头程费（RMB）（高）"
            show-overflow-tooltip
            width="200"
          >
          </el-table-column>

          <el-table-column
            prop="hytcfyLow"
            label="海运头程费（RMB）（低）"
            width="200"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="wcfy"
            label="尾程费用（RMB）"
            width="160"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="cpcRate"
            label="CPC预算费用（默认10%）"
            show-overflow-tooltip
            width="260"
          >
          </el-table-column>
          <el-table-column
            prop="cpcYsfy"
            label="CPC预算费用（站内RMB）"
            show-overflow-tooltip
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="ptf"
            label="平台费RMB"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="th"
            label="退货"
            width="120"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column prop="vat" label="VAT" show-overflow-tooltip>
          </el-table-column> -->

        <el-table-column prop="rate" label="汇率（中国银行1号汇率）" width="190" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="price" label="售价" show-overflow-tooltip> </el-table-column>

        <!-- <el-table-column
            prop="grossProfit"
            label="毛利润"
            show-overflow-tooltip
          >
          </el-table-column>

          <el-table-column
            prop="mlrl"
            label="毛利润率（%）"
            width="120"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="bsggfymlr"
            label="不算广告费用毛利润"
            show-overflow-tooltip
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="bsggfymlrl"
            label="不算广告费用毛利润率"
            show-overflow-tooltip
            width="180"
          >
          </el-table-column>
          <el-table-column prop="hytcfyType" width="120" label="海运头程类型">
            <div slot-scope="scope">
              {{
                scope.row.hytcfyType == 1
                  ? "官舱"
                  : scope.row.hytcfyType == 2
                  ? "三方"
                  : ""
              }}
            </div>
          </el-table-column>
          <el-table-column
            prop="khtcf"
            label="卡航头程费（RMB）"
            width="160"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="kytcf"
            label="空运头程费（RMB）"
            width="160"
            show-overflow-tooltip
          >
          </el-table-column> -->
        <el-table-column align="center" width="100">
          <template slot="header" slot-scope="scope">
            <span>操作</span>
          </template>
          <template slot-scope="scope">
            <el-link :underline="false" style="color: #7698fc" @click="editSkuinfo(scope.row)"><i class="iconfont icon-xiugai" title="编辑"></i></el-link>
          </template>
        </el-table-column>
      </el-table>
      <!--尾部-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 15, 20, 25, 30]"
        layout="total, sizes,prev, pager, next, jumper"
        :total="total"
        background
      />
      <!-- 新增sku弹框 -->

      <el-dialog :title="modelTitle" width="600px" :visible.sync="addRoleDialog" :close-on-click-modal="false" :show-close="false" left>
        <el-form label-width="160px" :model="addrole" ref="addrole" :rules="rules1">
          <el-form-item label="CPC预算费用(%)：" prop="cpcRate">
            <el-input v-model="addrole.cpcRate" type="number"></el-input>
          </el-form-item>
          <el-form-item label="售价：" prop="price">
            <el-input v-model="addrole.price" type="number"></el-input>
          </el-form-item>
          <el-form-item label="清关申报值：" prop="qgzbz">
            <el-input v-model="addrole.qgzbz" type="number"></el-input>
          </el-form-item>
          <el-form-item label="退货(%)：" prop="thRate">
            <el-input v-model="addrole.thRate" type="number"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button @click="cancelSku()">取 消</el-button>
            <el-button @click="addRole('addrole')" style="background-color: #4c74e0; color: white">提 交</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ElRow from "element-ui/packages/row/src/row";
import ElMain from "element-ui/packages/main/src/main";
import ElFooter from "element-ui/packages/footer/src/main";
import moment from "moment";
import SparkMD5 from "spark-md5";
export default {
  components: {
    ElFooter,
    ElMain,
    ElRow,
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  data() {
    var user = window.sessionStorage["user"];
    return {
      importSkuInfoShow: false,
      file: {},
      filterText: "" /*树形筛选绑定*/,
      props: {
        /*配置树形权限菜单显示*/
        label: "name",
        children: "children",
      },
      dataTypes: [
        {
          name: "内部",
          id: 11002001,
        },
        {
          name: "外部",
          id: 11002002,
        },
      ],
      /*创建角色*/
      addRoleDialog: false,
      addrole: {
        id: undefined,
        cpcRate: "",
        price: "",
        qgzbz: "",
        skuInfoId: "",
        thRate: "",
      },
      modelTitle: "",
      /*编辑角色*/
      editRoleDialog: false,
      editrole: {
        id: undefined,
        name: "",
        description: "",
        authorityIds: [],
      },
      rules1: {
        cpcRate: [{ required: true, message: "CPC预算费用是必填的", trigger: "blur" }],
        price: [{ required: true, message: "售价是必填的", trigger: "blur" }],
        qgzbz: [{ required: true, message: "清关申报值是必填的", trigger: "blur" }],
        thRate: [{ required: true, message: "退货是必填的", trigger: "blur" }],
      },
      data: [{}] /*绑定新增角色树的数据*/,
      dataBrands: [],
      dataSites: [],
      dataShops: [],
      formInline: {
        sku: "",
        attribute: "",
        shopName: "",
        site: "",
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      btn: false,
      fileList: [],
      file: {},
      row: "",
      col: "",
      tmpRow: {},
      Fnupload: {
        id: "",
        businessType: "",
      },
      uploadDialog: false,
      dialogVisible: false,
      fileFnList: [],
      businessType: 0,
      formFilename: "上传文件",
      downDialog: false,
      downDetailfnskuPdfPath: "",
      skuId: "",
      flagClick: false,
      // 双击修改
      cpcRateShow: false,
      thShow: false,
    };
  },
  created() {
    this.query(); /*绑定树*/
    this.getAllDicts();
    this.getAllShops();
  },
  methods: {
    getAllDicts() {
      /*获取所有字典*/
      this.axios.get("/api/dict/map").then((r) => {
        let data = r.data.data;
        for (var key in data) {
          if (key.indexOf("1120") == 0) {
            // 品牌
            this.dataBrands = data[key];
          }
          if (key.indexOf("1130") == 0) {
            // 站点
            let siteData = data[key];
            siteData.map((item) => {
              item.codeName = item.codeValue + "（" + item.codeName + "）";
            });
            this.dataSites = siteData;
          }
        }
      });
    },
    getAllShops() {
      /*获取所有字典*/
      this.axios.get("/api/shop/list").then((r) => {
        if (r.data.code == 200) {
          let data = r.data.data;
          this.dataShops = data;
        }
      });
    },
    // 双击编辑修改sku单元格数据
    editData(row, column) {
      if (column.label.indexOf("退货") == 0) {
        this.thShow = true;
      } else if (column.label.indexOf("CPC预算费用（站内RMB）") == 0) {
        this.cpcRateShow = true;
      }
      this.row = row.id;
      this.col = column.id;
      this.tmpRow = row;
      this.tmpRow.id = row.id;
      this.tmpRow.label = column.label;
    },

    //修改信息后调用修改信息的Api
    //双击失焦后的事件
    updateskuInfo() {
      let order = "";
      if (this.thShow && this.tmpRow.label == "退货") {
        order = { id: this.tmpRow.id, skuInfoId: this.tmpRow.skuInfoId, thRate: parseFloat(this.tmpRow.th) };
      } else if (this.cpcRateShow && this.tmpRow.label == "CPC预算费用（站内RMB）") {
        order = { id: this.tmpRow.id, skuInfoId: this.tmpRow.skuInfoId, cpcRate: parseFloat(this.tmpRow.cpcRate) };
      }
      if (order != null && order != "") {
        this.axios.put("/api/gross-profit-result/modify", order).then(
          (resp) => {
            if (resp.data.code == 200) {
              this.$message("修改成功");
              this.query(); /*查询渲染界面*/
            } else {
              this.$message.info(resp.data.msg);
            }
            //清空数据
            this.tmpRow = {};
            this.row = "";
            this.col = "";
          },
          (err) => {
            console.log("err", err);
          }
        );
      }
    },

    formatTime(row, column) {
      let date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
    handleSizeChange(val) {
      /*改变显示条数*/
      this.pageSize = val;
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange() {
      this.query();
    },
    putdata(resp) {
      console.log(resp.data, "resp.data");
      this.$data.tableData = resp.data.data && resp.data.data.records ? resp.data.data.records : [];
      this.$data.total = resp.data.data.total;
    },
    queryParams() {
      this.$data.currentPage = 1;
      this.query();
    },
    query() {
      //条件筛选
      let o = {
        ...this.formInline,
      };
      this.axios
        .get("/api/gross-profit-result/page", {
          params: { ...o, current: this.$data.currentPage, size: this.$data.pageSize },
        })
        .then(this.putdata, (err) => {
          console.log("err", err);
        });
    },
    cancelSku() {
      this.addrole = {
        id: undefined,
        cpcRate: "",
        price: "",
        qgzbz: "",
        skuInfoId: "",
        thRate: "",
      };
      this.addRoleDialog = false;
    },
    editSkuinfo(row) {
      /*绑定修改信息*/
      this.addRoleDialog = true;
      this.modelTitle = "修改毛利率信息";
      this.addrole = JSON.parse(JSON.stringify(row));
    },
    addRole(addrole) {
      /*新增修改*/
      this.$refs[addrole].validate((valid) => {
        if (valid) {
          let info = {
            cpcRate: parseFloat(this.addrole.cpcRate),
            price: this.addrole.price,
            id: this.addrole.id,
            qgzbz: this.addrole.qgzbz,
            thRate: parseFloat(this.addrole.thRate),
            skuInfoId: parseFloat(this.addrole.skuInfoId),
          };

          if (info.id) {
            this.axios.put("/api/gross-profit-result/modify", info).then(
              (resp) => {
                if (resp.data.code == 200) {
                  this.$message("修改成功");
                  this.query(); /*查询渲染界面*/
                  this.cancelSku(); /*关闭弹窗*/
                } else {
                  this.$message.info(resp.data.msg);
                }
              },
              (err) => {
                console.log("err", err);
              }
            );
          }
        } else {
          console.log("验证没通过");
          return false;
        }
      });
    },
    // 导入
    importSkuInfo() {
      this.importSkuInfoShow = true;
    },
    templateDownload() {
      this.$msgbox
        .confirm("此操作将下载模板, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          let baseurl = this.axios.defaults.baseURL;
          let path = "/order/template/SKU信息维护.xlsx";
          window.open(`${baseurl}/api/sku-info/templateDownload?path=` + path, "_blank");
          /*加个下载成功的进度条*/
          setTimeout(() => {
            this.$message({
              message: "下载成功",
              type: "success",
              center: true,
            });
          }, 500);
        })
        .catch(() => {
          this.$message.error("已取消下载");
        });
    },
    exportSkuInfo() {
      this.$msgbox
        .confirm("此操作将导出所有SKU信息, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          let baseurl = this.axios.defaults.baseURL;
          let path = "/order/template/SKU信息维护.xlsx";
          window.open(`${baseurl}/api/sku-info/exportSkuInfo`, "_blank");
          /*加个下载成功的进度条*/
          setTimeout(() => {
            this.$message({
              message: "下载成功",
              type: "success",
              center: true,
            });
          }, 500);
        })
        .catch(() => {
          this.$message.error("已取消下载");
        });
    },
    deleteRoleGetId(row) {
      /*删除角色*/
      this.$msgbox
        .confirm("此操作将删除SKU信息, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          this.axios.delete("/api/sku-info/removeById?id=" + row.id).then(
            (resp) => {
              if (resp.data.code == 200) {
                this.$message("删除成功");
                this.query();
              } else {
                this.$message(resp.data.msg);
              }
            },
            (err) => {
              console.log("err", err);
            }
          );
        })
        .catch(() => {
          this.$message.error("已取消");
        });
    },
    submitUpload(file, fileList) {
      this.file = file;
      let s = file.name;
      this.fileList = fileList.slice(-1);
      this.generatorFileMd5(file, this.setMD5);
    },
    generatorFileMd5(file, callback) {
      //声明必要的变量
      var fileReader = new FileReader(),
        //文件每块分割2M，计算分割详情
        chunkSize = 2097152,
        chunks = Math.ceil(file.size / chunkSize),
        currentChunk = 0,
        //创建md5对象（基于SparkMD5）
        spark = new SparkMD5();
      let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
      //每块文件读取完毕之后的处理
      fileReader.onload = function(e) {
        let called = false;
        //每块交由sparkMD5进行计算
        spark.appendBinary(e.target.result);
        currentChunk++;

        //如果文件处理完成计算MD5，如果还有分片继续处理
        if (currentChunk < chunks) {
          loadNext();
        } else {
          if (!called) {
            called = true;
            callback(spark.end());
          }
        }
      };

      //处理单片文件的上传
      function loadNext() {
        var start = currentChunk * chunkSize,
          end = start + chunkSize >= file.size ? file.size : start + chunkSize;

        fileReader.readAsBinaryString(blobSlice.call(file.raw, start, end));
      }

      loadNext();
    },
    setMD5(md5) {
      let formData = new FormData();
      // 向 formData 对象中添加文件
      // formData.append("md5", this.upload.md5);
      formData.append("file", this.file.raw);
      console.log(formData.get("file"), "formDataformData");
      let config = {
        //添加请求头
        headers: { "Content-Type": "multipart/form-data" },
        //添加上传进度监听事件
        onUploadProgress: (e) => {
          var completeProgress = (((e.loaded / e.total) * 100) | 0) + "%";
          this.progress = completeProgress;
        },
      };
      this.$http.post("/api/sku-info/importSkuInfo", formData, config).then(
        (resp) => {
          let baseurl = this.axios.defaults.baseURL;
          this.upload = {};
          if (resp.data.code == 200) {
            // 导入正确
            let path = resp.data.data.failFilePath;
            // failFilePath有的话是导入条目失败了 有失败原因
            if (path) {
              window.open(`${baseurl}/api/sku-info/templateDownload?path=` + path, "_blank");
            } else {
              this.importSkuInfoShow = false;
              this.fileList = [];
              this.query();
            }
            // 提示导入信息
            setTimeout(() => {
              this.$message(resp.data.data.result);
            }, 3000);
          } else {
            let path = resp.data.failFilePath;
            if (path) {
              path = "/order/template/SKU信息维护.xlsx";
            }
            window.open(`${baseurl}/api/sku-info/templateDownload?path=` + path, "_blank");
          }
        },
        (err) => {
          console.log("err", err);
        }
      );
    },

    uploadOrderfile(row) {
      console.log(row, "row");
      this.dialogVisible = true;
      this.Fnupload.id = row.id;
    },
    uploadBtnChange(type) {
      this.Fnupload.businessType = type;
      console.log(this.Fnupload.businessType, "this.businessType");
      if (this.Fnupload.businessType == 0) {
        this.formFilename = "PDF文件：";
      } else if (this.Fnupload.businessType == 1) {
        this.formFilename = "相关文件：";
      }

      this.fileFnList = [];
      this.uploadDialog = true;
    },
    submitFnUpload(file, fileFnList) {
      let s = file.name;
      this.fileFnList = fileFnList.slice(-1);
      this.Fnupload.file = file;
      this.generatorFileMd5(file, this.setFnMD5);
    },
    setFnMD5(md5) {
      const index = this.Fnupload.file.name.lastIndexOf(".");
      var flieArr = this.Fnupload.file.name.substring(index, this.Fnupload.file.name.length);
      // alert(flieArr)
      if (this.Fnupload.businessType == 0) {
        if (flieArr != ".pdf") {
          this.$message.error("请选择PDF文件！");
          this.fileFnList = [];
          return;
        }
      }
      let formData = new FormData();
      // 向 formData 对象中添加文件
      formData.append("file", this.Fnupload.file.raw);
      console.log(this.Fnupload.file, "formDatassssss");
      console.log(formData.get("file"), "formDataformData");
      let config = {
        //添加请求头
        headers: { "Content-Type": "multipart/form-data" },
        //添加上传进度监听事件
        onUploadProgress: (e) => {
          var completeProgress = (((e.loaded / e.total) * 100) | 0) + "%";
          this.progress = completeProgress;
        },
      };

      this.$http.post("/api/sku-info/file-upload?id=" + this.Fnupload.id + "&businessType=" + this.Fnupload.businessType, formData, config).then(
        (resp) => {
          this.Fnupload = {};
          if (resp.data.code == 200) {
            this.$message("上传成功");
            setTimeout(() => {
              this.uploadDialog = false;
              this.dialogVisible = false;
            }, 500);

            this.query();
          } else {
            this.$message("上传失败");
          }
        },
        (err) => {
          console.log("err", err);
        }
      );
    },
    clickFnskuDown(row) {
      this.downDialog = true;
      this.skuId = row.id;
      this.downDetailfnskuPdfPath = row.fnskuPdfPath;
    },
    downFileFnsku(businessType) {
      this.axios.get("/api/sku-info/validSkuIsDownload?id=" + this.skuId + "&businessType=" + businessType).then(
        (resp) => {
          if (resp.data.code == 200) {
            let baseurl = this.axios.defaults.baseURL;
            window.open(`${baseurl}/api/sku-info/fnsku-download?id=` + this.skuId + `&businessType=` + businessType, "_blank");

            setTimeout(() => {
              this.downDialog = false;
              this.$message({
                message: "下载成功",
                type: "success",
                center: true,
              });
            }, 1000);
          } else {
            this.$message.info("暂未上传文件");
          }
        },
        (err) => {
          console.log("err", err);
        }
      );
    },
  },
  mounted: function() {
    this.active = this.$route.name;
    this.query();
  },
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  height: calc(100vh - 70px);
  overflow: hidden;
  .title {
    height: 50px !important;
    color: white;
    font-size: 16px;
    background: #c1a1ca;
    line-height: 50px;
    font-family: Source Han Sans CN;
    font-weight: 400;
  }
  &-content {
    background-color: white;
    height: calc(100vh - 50px);
    overflow: hidden;
    .el-form{
      width: 100%;
      height: 36px;
      line-height: 36px;
      margin-top: 15px;
    }
  }
  /*分页插件*/
  .el-pagination {
    background-color: #fff;
    padding: 15px;
    text-align: center;
    z-index: 55555;
  }
}
.center-dialog {
  top: 20%;
}
.el-pagination.is-background /deep/ .el-pager li:not(.disabled).active {
  background-color: #c1a1ca;
}

/*滚动条样式*/
/deep/ .scrollbar {
  white-space: nowrap;
  .el-scrollbar {
    display: flex;
    justify-content: space-around;
    padding: 0 10px;
  }
  /deep/ .el-scrollbar__wrap {
    overflow: scroll;
    width: 110%;
    height: 100%;
  }
}

.ant-card {
  width: 1230px;
  height: 600px;
  background: #ffffff;
  border-radius: 6px;

  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  transition: all 0.3s;
}
.showAll_dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  ::v-deep .el-dialog {
    margin: 0 auto !important;
    height: 40%;
    overflow: hidden;
    .el-dialog__body {
      position: absolute;
      left: 0;
      top: 54px;
      bottom: 0;
      right: 0;
      padding: 0;
      z-index: 1;
      overflow: hidden;
      overflow-y: auto;
      // 下边设置字体，我的需求是黑底白字
      color: #ffffff;
      line-height: 30px;
      padding: 0 15px;
    }
  }
}
</style>
